import { Link, useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { navigationItems } from '../../constants/navigation.constants';
import { cn } from '../../utils/cn';
import { useAuth } from '../../hooks';

export function Sidebar() {
  const location = useLocation();
  const { logout } = useAuth();

  const isActive = (path?: string) => {
    if (!path) return false;
    return location.pathname === path;
  };

  return (
    <aside className="w-64 bg-white text-gray-900 min-h-screen flex flex-col border-r border-gray-200">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-gray-200">
        <h1 className="text-[19px] font-semibold tracking-tight text-gray-900">
          Stepto<span className="font-normal">TRAVEL</span>
        </h1>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-2">
        <ul>
          {navigationItems.map((item) => {
            if (item.isSection) {
              return (
                <li key={item.id} className="px-6 pt-7 pb-2">
                  <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-[0.1em]">
                    {item.label}
                  </span>
                </li>
              );
            }

            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <li key={item.id}>
                <Link
                  to={item.path || '#'}
                  className={cn(
                    'flex items-center gap-3 px-6 py-3 transition-colors text-sm relative',
                    active
                      ? 'bg-blue-50 text-blue-600 font-medium before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1 before:bg-blue-600'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                  )}
                >
                  {Icon && <Icon className="w-[18px] h-[18px] flex-shrink-0" />}
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Logout */}
      <div className="px-6 py-4 border-t border-gray-200">
        <button
          onClick={logout}
          className="flex items-center gap-3 py-2.5 w-full text-gray-700 hover:text-gray-900 transition-colors text-sm"
        >
          <LogOut className="w-[18px] h-[18px] flex-shrink-0" />
          <span>Выйти</span>
        </button>
      </div>
    </aside>
  );
}
